document.addEventListener('DOMContentLoaded', function() {
  const swiperElement = document.querySelector('.cards-grid-mobile-swiper');
  
  if (swiperElement) {
    const swiper = new Swiper('.cards-grid-mobile-swiper', {
      slidesPerView: 1.2,
      spaceBetween: 12,
      loop: false,
      allowTouchMove: true,
    });
  }
});
